import { Outlet } from 'react-router';
import styles from './AuthLayout.module.css';

function AuthLayout() {
    return (
        <div className={styles.authLayout}>
            <Outlet />
        </div>
    );
}

export default AuthLayout;